<template>
  <div class="login-container">
    <div class="login-box">
      <h2>登录</h2>
      <el-form :model="form" :rules="rules" ref="loginForm" label-width="80px">
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="form.email"
            placeholder="请输入邮箱地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="form.pwd"
            type="password"
            placeholder="请输入密码"
            @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item>
        <el-form-item class="btn_form">
          <el-button type="primary" @click="handleLogin" class="login-button">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { sendCode, login } from "@/api/login";
export default {
  name: "LoginPage",
  data() {
    // 邮箱验证规则
    const validateEmail = (rule, value, callback) => {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!value) {
        return callback(new Error("请输入邮箱地址"));
      }
      if (!emailRegex.test(value)) {
        callback(new Error("请输入有效的邮箱地址"));
      } else {
        callback();
      }
    };
    return {
      form: {
        email: "",
        // code: "",
        pwd: "",
        is_back: "1", //1:后台登录
      },
      rules: {
        email: [{ required: true, validator: validateEmail, trigger: "blur" }],
        // code: [
        //   { required: true, message: "请输入验证码", trigger: "blur" },
        //   { len: 6, message: "验证码为6位数字", trigger: "blur" },
        // ],
        pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      isCounting: false,
      countdown: 0,
      countdownTimer: null,
      btnLoding: false,
    };
  },
  created() {},
  methods: {
    sendVerificationCode() {
      this.$refs.loginForm.validateField("email", (valid) => {
        if (!valid) {
          this.isCounting = true;
          this.countdown = 60;
          this.countdownTimer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(this.countdownTimer);
              this.isCounting = false;
            }
          }, 1000);

          // 这里调用发送验证码API
          sendCode({ email: this.form.email })
            .then((response) => {
              console.log(response);
              this.$message.success("验证码已发送至您的邮箱");
            })
            .catch((error) => {
              console.error(error);
              this.$message.error(
                error.response.data.message || "发送验证码失败，请稍后重试"
              );
            });
        }
      });
    },
    // 点击登录按钮
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // 调用注册API
          login(this.form)
            .then((res) => {
              if (res.code == 1) {
                this.$message.success("登录成功");
                localStorage.setItem("token", res.data.token);
                localStorage.setItem("user_id", res.data.user_id);
                this.$router.push("/home");
              } else {
                this.$message.error("登录失败 请稍后重试");
              }
            })
            .catch((error) => {
              console.error(error);
              this.$message.error(
                error.response.data.message || "登录失败 请稍后重试"
              );
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
/* 渐变霓虹风格 */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  animation: gradient 15s ease infinite;
}

.login-box {
  width: 400px;
  padding: 2.5rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

h2 {
  text-align: center;
  margin-bottom: 2rem;
  color: #2d3748;
  font-weight: 700;
  font-size: 2rem;
}

::v-deep .el-input__inner {
  height: 50px;
  border-radius: 10px;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;

  &:focus {
    border-color: #ff6b6b;
    box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.1);
  }
}

.login-button {
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 10px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ffa726 100%);
  border: none;
  color: white;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 10px 20px rgba(255, 107, 107, 0.3);
  }
}

.register-link {
  text-align: center;
  margin: 20px 0;
  font-size: 14px;
  color: #666;
}

.register-text {
  color: #48bb78;
  cursor: pointer;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  margin-left: 5px;

  &:hover {
    color: #38a169;
    text-decoration: underline;
  }
}
.code-input-container {
  display: flex;
  gap: 12px;

  ::v-deep .el-input {
    flex: 1;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>

<style lang="scss" scoped>
/* 手机端布局 */
@media (max-width: 767px) {
  .login-box {
    width: 300px;
    padding: 0 20px 0 0;
  }
}
</style>
